import Vue from "vue";
import Router from "vue-router";
import Index from "../views/index.vue";
import Home from "../views/home.vue";
import Login from "../login/index.vue";
//文章
import News from "../views/news/news.vue";
import NewsList from "../views/news/NewsList.vue";
import NewsContent from "../views/news/newsContent.vue";
import UpdateNews from "../views/news/updateNews.vue";
//轮播
import SlideshowList from "../views/slideshow/slideshowList.vue";
import AddSlideshow from "../views/slideshow/addSlideshow.vue";
//案例
import CaseList from "../views/case/caseList.vue";
 import AddCase from "../views/case/addCase.vue";
 import UpdateCase from "../views/case/updateCase.vue";
// import CaseContent from "../views/case/caseContent.vue";




Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      redirect:"/index",
      children: [
        { path: "/index", name: "index", component: Index },

        {
          path: "/news",
          name: "news",
          component: News
        },
        {
          path: "/newsList",
          name: "newsList",
          component: NewsList
        },
        {
          path: "/updateNews",
          name: "updateNews",
          component: UpdateNews
        },
        {
          path: "/newsContent",
          name: "newsContent",
          component: NewsContent
        },
        {
          path: "/slideshowList",
          name: "slideshowList",
          component: SlideshowList
        },
        {
          path: "/addSlideshow",
          name: "addSlideshow",
          component: AddSlideshow
        },
        {
          path: "/caseList",
          name: "caseList",
          component: CaseList
        },
        {
          path: "/addCase",
          name: "addCase",
          component: AddCase
        },
        {
          path: "/updateCase",
          name: "UpdateCase",
          component: UpdateCase
        },


      ]
    },
    {
      path: "/login",
      name: "login",
      component: Login
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js